export const psychotherapyArticles = [
  {
    id: 8,
    titles: {
      en: "A Qualitative Meta-analytic Review of the Therapist Responsiveness Literature: Guidelines for Practice and Training",
      it: "Una Revisione Meta-analitica Qualitativa della Letteratura sulla Responsività del Terapeuta: Linee Guida per la Pratica e la Formazione"
    },
    authors: ["Wu M.", "Levitt H."],
    descriptions: {
      en: "A comprehensive meta-analytic review examining therapist responsiveness in psychotherapy, providing evidence-based guidelines for clinical practice and training programs to enhance therapeutic effectiveness.",
      it: "Una revisione meta-analitica completa che esamina la responsività del terapeuta in psicoterapia, fornendo linee guida basate sull'evidenza per la pratica clinica e i programmi di formazione per migliorare l'efficacia terapeutica."
    },
    publishDate: "2024-01-20",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/7a394d7d-3100-4b56-9783-7ad63f063f31/introduction-therapist-responsiveness",
        mindmap: "https://whimsical.com/3NwhLW5Dvx1oUjfepXQ61C",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8wLzEvMS8wMDowMDowMC80NzU4MzExLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/730d47bf-218c-479b-943b-f225eb4a79a6/introduzione-responsivita-terapeuta",
        mindmap: "https://whimsical.com/responsivita-del-terapeuta-Dv7h1KDBNTrmPkC6Hkm57u",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8wLzAvMS8xLzEvMDA6MDA6MDAvNTExMDQ4NS8x"
      }
    }
  },
  {
    id: 9,
    titles: {
      en: "Therapist Performance Under Pressure Part 1: Negotiating Emotion, Difference, and Rupture",
      it: "Performance del Terapeuta Sotto Pressione Parte 1: Negoziare Emozione, Differenza e Rottura"
    },
    authors: ["J. Christopher Muran", "Catherine F. Eubanks"],
    descriptions: {
      en: "Part one of a comprehensive examination of how therapists perform under challenging clinical situations, focusing on managing emotions, cultural differences, and therapeutic ruptures in the therapeutic relationship.",
      it: "Prima parte di un esame completo di come i terapeuti si comportano in situazioni cliniche difficili, concentrandosi sulla gestione delle emozioni, delle differenze culturali e delle rotture terapeutiche nella relazione terapeutica."
    },
    publishDate: "2024-02-15",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/7a394d7d-3100-4b56-9783-7ad63f063f31/introduction-therapist-performance",
        mindmap: "https://whimsical.com/therapist-performance-under-pressure-MvoXcwXAZRfGu63UZHhvZx",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8wLzEvMS8wMDowMDowMC80NzU3NjExLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/8d5aff48-0a55-4237-9e8a-1977059a09ee/introduzione-performance-terapeutica",
        mindmap: "https://whimsical.com/therapist-performance-under-pressure-MvoXcwXAZRfGu63UZHhvZx",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8wLzAvMS8xLzEvMDA6MDA6MDAvNTExMTQyMC8x"
      }
    }
  },
  {
    id: 10,
    titles: {
      en: "Therapist Performance Under Pressure Part 2: Negotiating Emotion, Difference, and Rupture",
      it: "Performance del Terapeuta Sotto Pressione Parte 2: Negoziare Emozione, Differenza e Rottura"
    },
    authors: ["J. Christopher Muran", "Catherine F. Eubanks"],
    descriptions: {
      en: "The second part of this essential guide for therapists, continuing the exploration of clinical skills needed when working under pressure and managing complex therapeutic dynamics.",
      it: "La seconda parte di questa guida essenziale per i terapeuti, continuando l'esplorazione delle competenze cliniche necessarie quando si lavora sotto pressione e si gestiscono dinamiche terapeutiche complesse."
    },
    publishDate: "2024-03-01",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/40370d56-5bf4-41a5-b2ce-8d9173fa5630/introduction-therapist-challenges",
        mindmap: "https://whimsical.com/8NvkBR42QWPZn4JCkGeP6f",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8wLzEvMS8wMDowMDowMC80NzU3NjExLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/334e7881-ffa7-4990-b9bd-ee1cd6a970d6/introduzione-sfide-pressioni-terapeuta",
        mindmap: "https://whimsical.com/therapist-performance-under-pressure-3SUAbY7vCpfSnV2yu1x11e",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8wLzAvMS8xLzEvMDA6MDA6MDAvNTE2MjI1NS8x"
      }
    }
  },
  {
    id: 11,
    titles: {
      en: "Positive events in Psychotherapy, what do adolescents and young says it's helpful?",
      it: "Eventi Positivi in Psicoterapia, cosa dicono gli adolescenti e i giovani che sia utile?"
    },
    authors: ["Luisa Cassera", "Alessia Calabrò", "Aschieri Filippo"],
    descriptions: {
      en: "A qualitative study exploring positive therapeutic events from the perspective of adolescent and young adult clients, providing insights into what makes psychotherapy helpful and effective for this population.",
      it: "Uno studio qualitativo che esplora gli eventi terapeutici positivi dalla prospettiva di clienti adolescenti e giovani adulti, fornendo intuizioni su ciò che rende la psicoterapia utile ed efficace per questa popolazione."
    },
    publishDate: "2024-03-25",
    availableLanguages: ['en'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/3ede751b-04a1-45bd-8e65-5dcbb75a0078/introduction-to-the-study",
        mindmap: "https://whimsical.com/adolescents-experiences-of-positive-events-in-psychotherapy-W5XQqjb53qthFCEifJbEJx",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzAvMC8xLzEvMS8wMDowMDowMC80ODc1OTM3LzE="
      }
    }
  },
  {
    id: 12,
    titles: {
      en: "Hindering events in psychotherapy with adolescents: A retrospective investigation of patients' recollection",
      it: "Eventi ostacolanti in psicoterapia con adolescenti: Un'indagine retrospettiva del ricordo dei pazienti"
    },
    authors: ["Alessia Calabrò", "Luisa Cassera", "Filippo Aschieri"],
    descriptions: {
      en: "A retrospective study examining hindering events in adolescent psychotherapy from the patient's perspective, identifying factors that impede therapeutic progress and providing recommendations for clinical practice.",
      it: "Uno studio retrospettivo che esamina gli eventi ostacolanti nella psicoterapia degli adolescenti dalla prospettiva del paziente, identificando i fattori che impediscono il progresso terapeutico e fornendo raccomandazioni per la pratica clinica."
    },
    publishDate: "2024-04-10",
    availableLanguages: ['en'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/bfbf2ddb-4e12-4533-a201-91393fc38d03/introduction-hindering-events-adolescent-psychotherapy",
        mindmap: "https://whimsical.com/hindering-events-in-adolescent-psychotherapy-4sprUKscUJE41ZgaWVnXZL",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMC8wMDowMDowMC80ODc4NjM4LzE="
      }
    }
  },
  {
    id: 13,
    titles: {
      en: "The Thread of the Self and Useful Care",
      it: "Il filo del Sé e l'accudimento utile"
    },
    authors: ["Vetere Marcellino", "Mattucci Aldo"],
    descriptions: {
      en: "An in-depth exploration of the concept of 'thread of the Self' and useful care in psychotherapeutic practice, offering an innovative Italian perspective on therapeutic care and identity development.",
      it: "Un'esplorazione approfondita del concetto di 'filo del Sé' e dell'accudimento utile nella pratica psicoterapeutica, offrendo una prospettiva italiana innovativa sulla cura terapeutica e lo sviluppo dell'identità."
    },
    publishDate: "2024-04-20",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/9c3eedd8-48b8-4fbc-a678-47198d6ac9e9/introduction-useful-care-dependency",
        mindmap: "https://whimsical.com/generated-board-LjvN4xmtyFvpUGrZSLqdvR",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MjQ4MzcwLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/59d91953-d30a-4545-a42a-60a97e9f7686/introduzione-cosmoeducation-accudimento-utile",
        mindmap: "https://whimsical.com/il-filo-del-se-e-l-accudimento-utile-Q9b9kHePE8JSQC6AAWnvam",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNDk1MjY0Ny8x"
      }
    }
  },
  {
    id: 32,
    titles: {
      en: "Mentalization: Ontogenesis, Assessment and Applications in Treatment of Borderline Personality Disorder",
      it: "Mentalizzazione: ontogenesi, valutazione e applicazioni nel trattamento del disturbo borderline di personalità"
    },
    authors: ["Lois W. Choi-Kain", "John G. Gunderson"],
    descriptions: {
      en: "A comprehensive exploration of mentalization theory, examining its developmental origins, assessment methods, and clinical applications specifically in the treatment of borderline personality disorder, providing essential insights for therapeutic practice.",
      it: "Un'esplorazione completa della teoria della mentalizzazione, esaminando le sue origini evolutive, i metodi di valutazione e le applicazioni cliniche specificamente nel trattamento del disturbo borderline di personalità, fornendo intuizioni essenziali per la pratica terapeutica."
    },
    publishDate: "2024-07-01",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/92784ea5-5fe3-45b8-ab2a-c492cc38409b/introduction-to-mentalization-and-its-importance",
        mindmap: "https://whimsical.com/mentalization-in-borderline-personality-85i4AxK8js4i3PFcHBoHQs",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81NDAzNjUyLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/331b8051-e490-4f08-8330-29a80764f3f1/introduzione-mentalizzazione-importanza",
        mindmap: "https://whimsical.com/mentalizzazione-borderline-EHNQX4htrvH1Uo1PcBibSq",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTQwMzY0My8x"
      }
    }
  },
  {
    id: 37,
    titles: {
      en: "Mental Health and Psychotherapy",
      it: "Salute mentale e psicoterapia"
    },
    authors: ["Paolo Gritti"],
    descriptions: {
      en: "A tribute to Paolo Gritti on the integration of psychotherapy and mental health.",
      it: "Un tributo a Paolo Gritti sull'integrazione della psicoterapia e la salute mentale."
    },
    publishDate: "2024-08-30",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/9dc6a3cd-c0f2-47b7-a01d-04710805c7c6/tribute-paolo-gritti-central-question",
        mindmap: "https://whimsical.com/carlo-s-workspace765/clinical-intervention-model-in-developmental-age-4ox9DypmgK34qwGG1nwBdW",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81NjgyNDUwLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/78fb7d5b-14fc-47ca-b24c-777f1d193e9c/tributo-paolo-gritti-integrazione-psicoterapia",
        mindmap: "https://whimsical.com/carlo-s-workspace765/paolo-gritti-mental-health-and-psychotherapy-2vPpMknM6rWVj8fhfZ5ar2",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTY1MzA1Ny8x"
      }
    }
  },
  {
    id: 38,
    titles: {
      en: "My Philosophy of Psychotherapy",
      it: "La mia filosofia della psicoterapia"
    },
    authors: ["Carl Whitaker"],
    descriptions: {
      en: "Carl Whitaker's personal philosophy of psychotherapy, exploring his innovative approaches to family therapy and his unique perspective on therapeutic relationships and healing processes.",
      it: "La filosofia personale di psicoterapia di Carl Whitaker, esplorando i suoi approcci innovativi alla terapia familiare e la sua prospettiva unica sulle relazioni terapeutiche e i processi di guarigione."
    },
    publishDate: "2024-09-15",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/810fb3f3-2bed-4506-8e78-1fda9533aea1/formative-influences-origins",
        mindmap: "https://whimsical.com/carlo-s-workspace765/my-philosophy-of-psychotherapy-carl-a-whitaker-DByK1gWaq2dKtAKxgueyDE",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzAvMC8xLzEvMS8wMDowMDowMC81NzM2MjQyLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/033ee594-8ebb-488c-83a8-deb6b91b3ad5/introduzione-filosofia-whitaker",
        mindmap: "https://whimsical.com/carlo-s-workspace765/la-mia-filosofia-della-psicoterapia-carl-a-whitaker-QMpVqcY9tgC9CrmJYH3KwU",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTczNjE5MC8x"
      }
    }
  }
];